<div class="progress-bar-wrapper">
    <div class="progress-bar-title"><span class="memory-size"></span><span class="property-title"><span>Cpu {{ this.cpuCores() }}
        cores </span> <span>{{ this.cpuUsage().toFixed(2) }}%</span></span><span
            class="memory-size"></span></div>
    <div class="progress-bar-custom" style="--width: 0 ; --pseudoEl: 'lightgreen'"
         [ngStyle]="{'--width' : progressWidth()}">
    </div>
</div>
